import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import AppHeader from "@astina/paloma-common-ui/src/components/AppHeader.vue";
import AppUserInfo from "../components/AppUserInfo.vue";
import ShoppingCart from "../components/ShoppingCart.vue";
import WatchlistContext from "../components/WatchlistContext.vue";
import config from '../services/PortalConfig';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PortalAppHeader',
    setup(__props) {
        const navItems = [
            {
                name: 'catalog',
                permission: 'PORTAL_CATALOG_VIEW',
            },
            {
                name: 'demand',
                permission: 'PORTAL_DEMAND_VIEW',
            },
            {
                name: 'orders',
                permission: 'PORTAL_ORDERS_VIEW',
            },
            {
                name: 'deliveries',
                permission: 'PORTAL_DELIVERIES_VIEW',
            },
        ];
        // add custom nav items
        config.headerNavItems.forEach(item => navItems.push(item));
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(AppHeader, {
                "nav-items": navItems,
                variant: "light",
                "nav-variant": "strong"
            }, {
                user: _withCtx(() => [
                    _createVNode(AppUserInfo)
                ]),
                context: _withCtx(() => [
                    _createVNode(WatchlistContext),
                    _cache[0] || (_cache[0] = _createTextVNode()),
                    _createVNode(ShoppingCart)
                ]),
                _: 1
            }));
        };
    }
});
